import { useI18n } from "@haohan/root-locales"

export const useUrlWithNext = (path: string, withLang = false) => {
    const { lang } = useI18n();
    let query = '';
    if (typeof location != 'undefined') {
        if (location.search) {
            query = location.search;
        }
    }
    let href = `${path}${query}`;
    if (withLang) {
        href = `/${lang}` + href;
    }
    return href;
}

export const getNextPath = () => {
    let query = '';
    if (typeof location != 'undefined') {
        if (location.search) {
            query = location.search;
        }
    }
}
